import { useState } from 'react';
import { UserCircleIcon } from '@phosphor-icons/react';

import { AccountSettingsModal } from '@/features/settings/components/AccountSettingsModal';
import { DropdownMenuItem } from '@/ui/DropdownMenu';
import { SidebarUserMenu } from './SidebarUserMenu';

export function SidebarFooter() {
  const [isAccountSettingsOpen, setIsAccountSettingsOpen] = useState(false);

  return (
    <div className="flex flex-col gap-2.5">
      <SidebarUserMenu
        menuItems={
          <DropdownMenuItem onSelect={() => setIsAccountSettingsOpen(true)}>
            <UserCircleIcon size={15} />
            Account settings
          </DropdownMenuItem>
        }
      />

      <AccountSettingsModal isOpen={isAccountSettingsOpen} onClose={() => setIsAccountSettingsOpen(false)} />
    </div>
  );
}
